<template>
    <div
        class="font-sans bg-white shadow border border-solid border-white rounded-[16px] flex flex-col"
        data-test="flow-row"
    >
        <div class="px-6 py-6 flex flex-col rounded-[16px] relative gap-4 grow lg:flex-row lg:items-center lg:py-4">
            <div class="">
                <h3 class="block text-lg font-bold text-slate-800 truncate leading-normal m-0" data-test="flow-name">
                    {{ props.modelValue.name }}
                </h3>
                <div class="text-xs text-slate-500">
                    <div class="line-clamp-3 lg:line-clamp-2">
                        {{ props.modelValue.notes }}
                    </div>
                </div>
            </div>

            <div class="flex gap-2 mt-auto lg:my-0 lg:ml-auto lg:grow-0">
                <vx-dropdown teleport placement="left">
                    <vx-button class="w-11" type="button" color="muted" outline size="md">
                        <font-awesome-icon widthAuto :icon="faEllipsis" />
                    </vx-button>

                    <template v-slot:items>
                        <vx-dropdown-item @click.prevent="removeModal = true" type="button" data-test="remove-flow">
                            Delete <font-awesome-icon widthAuto :icon="faTrashCan"></font-awesome-icon>
                        </vx-dropdown-item>
                    </template>
                </vx-dropdown>

                <vx-button
                    color="muted"
                    :outline="true"
                    :href="'/automation/flows/' + props.modelValue.flow_id + '/resources'"
                    class="grow"
                >
                    Edit
                    <font-awesome-icon widthAuto :icon="faFilePen"></font-awesome-icon>
                </vx-button>
            </div>
        </div>

        <flow-delete
            v-model:visible="removeModal"
            :flowId="props.modelValue.flow_id"
            @deleted="emit('deleted')"
        ></flow-delete>
    </div>
</template>

<script setup>
import { faEllipsis, faFilePen, faTrashCan } from '@fortawesome/pro-solid-svg-icons';
import { VxButton, VxDropdown, VxDropdownItem } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import FlowDelete from './FlowDelete.vue';
import { ref } from 'vue';

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
});

const removeModal = ref(false);

const emit = defineEmits(['deleted']);
</script>
